import DTO from './DTO';

class GeographyDTO extends DTO {
  geography_type;

  geography_id;

  geography_json;

  effective_date;

  published_date;

  retire_date;

  prev_geographies;

  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'geography.name',
      },
      {
        name: 'description',
        type: String,
        validators: [],
        labelKey: 'geography.description',
      },
      {
        name: 'geography_type',
        type: String,
        validators: [],
        labelKey: 'geography.geography_type',
      },
      {
        name: 'geography_id',
        type: String,
        validators: [],
        labelKey: 'geography.geography_id',
      },
      {
        name: 'geography_json',
        type: Object,
        validators: [],
        labelKey: 'geography.geography_json',
      },
      {
        name: 'effective_date',
        type: Number,
        validators: [],
        labelKey: 'geography.effective_date',
      },
      {
        name: 'published_date',
        type: Number,
        validators: [],
        labelKey: 'geography.published_date',
      },
      {
        name: 'retire_date',
        type: Number,
        validators: [],
        labelKey: 'geography.retire_date',
      },
      {
        name: 'prev_geographies',
        type: Array,
        validators: [],
        labelKey: 'geography.prev_geographies',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      name: this.name,
      description: this.description,
      geography_type: this.geography_type,
      geography_id: this.geography_id,
      geography_json: this.geography_json,
      effective_date: this.effective_date,
      published_date: this.published_date,
      retire_date: this.retire_date,
      prev_geographies: this.prev_geographies,
    };
  }
}

export default GeographyDTO;
